import socketIoClient from 'socket.io-client'
import sailsIo from 'sails.io.js'

export default {
  init (context, opts) {
    return new Promise((resolve, reject) => {
      if (!context.state.io) {
        const isProductionEnvironment = import.meta.env.PROD
        const io = sailsIo(socketIoClient)
        let disconnectTimer = null
        let flashSent = false
        io.sails.reconnection = false
        if (isProductionEnvironment || location.protocol === 'https:') {
          io.sails.url = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`
        } else {
          io.sails.url = `${location.protocol}//${location.hostname}:${import.meta.env.TEST ? 1340 : 1338}`
        }
        io.sails.environment = import.meta.env.MODE || 'development'
        io.sails.useCORSRouteToGetCookie = false
        context.commit('IO', io)

        const reconnect = () => {
          context.commit('ENROLLED', false)
          setTimeout(() => {
            io.socket.reconnect()
          }, 5000)
        }
        const sendFlash = () => {
          disconnectTimer = null
          flashSent = true
          context.dispatch('Flash/flash', { kind: 'negative', messages: 'Connection to server interrupted', timeout: 3000 }, { root: true })
          context.commit('OFFLINE', true)
        }
        io.socket.on('disconnect', () => {
          console.log('disconnect')
          if (!disconnectTimer) {
            disconnectTimer = setTimeout(sendFlash, 10000)
          }
          reconnect()
        })
        io.socket.on('connect_error', (e) => {
          console.log(e)
          if (!disconnectTimer) {
            disconnectTimer = setTimeout(sendFlash, 10000)
          }
          reconnect()
        })
        io.socket.on('reconnect_error', (e) => {
          console.log(e)
          if (!disconnectTimer) {
            disconnectTimer = setTimeout(sendFlash, 10000)
          }
          reconnect()
        })
        io.socket.on('connect', () => {
          console.log('connect')
          if (disconnectTimer) {
            clearTimeout(disconnectTimer)
          }
          if (flashSent) {
            flashSent = false
            context.dispatch('Flash/flash', { kind: 'positive', messages: 'Connection to server restored', timeout: 2000 }, { root: true })
          }
          if (context.rootState.User.authenticated) {
            context.dispatch('enroll')
          }
        })
        const models = [
          'Backup',
          'Fileset',
          'Group',
          'Grouppermission',
          'Integrator',
          'Organization',
          'Orphan',
          'Resourcetag',
          'Retention',
          'Scanresult',
          'Schedule',
          'System',
          'Tag',
          'Tagtype',
          'User',
          'UserOrg',
          'UserSystemFavorite'
        ]
        for (const model of models) {
          io.socket.on(model.toLowerCase(), (message) => {
            const opts = (message.id) ? message.id : message.data
            switch (message.verb) {
              case 'updated':
                context.dispatch(`${model}/updated`, opts, { root: true })
                break
              case 'created':
                context.dispatch(`${model}/created`, opts, { root: true })
                break
              case 'destroyed':
                context.dispatch(`${model}/destroyed`, opts, { root: true })
                break
            }
          })
        }
      }
      resolve()
    })
  },
  enroll (context, opts) {
    if (context.state.io && !context.state.enrolled && !context.state.enrolling && context.rootState.User.authenticated) {
      context.commit('ENROLLING', true)
      try {
        context.state.io.socket.get('/api/app/subscribe', (body, response) => {
          context.commit('ENROLLING', false)
          if (response.statusCode === 200) {
            context.commit('OFFLINE', false)
            context.commit('ENROLLED', true)
          } else if (response.statusCode === 401) {
            window.location.reload()
          } else {
            setTimeout(() => {
              context.dispatch('enroll')
            }, 5000)
          }
        })
      } catch (e) {
        context.commit('ENROLLING', false)
        setTimeout(() => {
          context.dispatch('enroll')
        }, 5000)
      }
    }
  },
  unenroll (context, opts) {
    if (context.state.io && context.state.enrolled && !context.rootState.User.authenticated) {
      try {
        context.state.io.socket.get('/api/app/unsubscribe', (body, response) => {
          console.log('unenrolled3')
          context.commit('ENROLLED', false)
        })
      } catch (e) {
        console.log('unenrolled4')
        context.commit('ENROLLED', false)
      }
    }
  }
}
